import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ReportsService } from "../services/reports.service";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { LmsService } from "../../_Lms/services/lms.service";
declare var $: any;
import { ActivatedRoute, Params } from "@angular/router";
import * as moment from "moment";
import { FlatTreeControl } from "@angular/cdk/tree";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";

interface Report {
  level: number;
  Branch_Name?: string;
  Product_Name?: string;
  LoanIds?: string;
  NoOfLoans?: string;
  POS_OS?: string;
  IN_Percentage: number;
  TotalBusiness?: number;
  Avg_LTV?: number;
  Avg_Tenure?: number;
  children?: Report[];
}

//   Id": 1,
//         "ParentId": 0,
//         "ProductId": 0,
//         "Product_Name": null,
//         "Branch_Name": "AMBABARI",
//         "LoanIds": "1453",
//         "NoOfLoans": "1",
//         "POS_OS": null,
//         "IN_Percentage": "0.12",
//         "TotalBusiness": "20000.00",
//         "BranchId
// }

interface ReportFlatNode {
  expandable: boolean;
  level: number;
  Branch_Name?: string;
  Product_Name?: string;
  LoanIds?: string;
  NoOfLoans?: string;
  POS_OS?: string;
  IN_Percentage: number;
  TotalBusiness?: number;
  Avg_LTV?: number;
  Avg_Tenure?: number;
}

@Component({
  selector: "app-business-wise",
  templateUrl: "./business-wise.component.html",
  styleUrls: ["./business-wise.component.scss"],
})
export class BusinessWiseComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  chartdata: any;
  JsonData: any[] = [];
  dataSource: any;
  SlabData: any[] = [];
  // ExpandBtn: boolean = true;
  // CollaspeBtn: boolean = false;
  //Form value
  selectedBranchRow: string = '';
  selectedProductRow: string = '';
  branchNameToIdMap: { [key: string]: number } = {};
  productNameToIdMap: { [key: string]: number } = {};
  ReportType: any = "";
  SlabId: any = "";
  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();
  displayedTreeColumns: string[];
  
  //div hidden show
  SlabDropdown: boolean = false;
  DataDiv: boolean = false;
  displayedColumns: string[];
  DataSourceModel: any = [];
  FileCheckingList: any;

  displayedColumnsModel: string[] = [];
  femaleLoans = 0;
  maleLoans = 0;
  femaleBusiness = 0;
  maleBusiness = 0;
  femalePercentage = 0;
  malePercentage = 0;
  Total_Loan = 0;
  Total_Business = 0;
  BranchId: any;
  ProductId: any;
  columnDisplayNames: { [key: string]: string } = {
    Id: "#",
    Application_No: "Application No",
    Application_Date: "Application Date",
    LoanAcNo: "Loan A/c No",
    Loan_Date: "Loan Date",
    Loan_Acc_Category: "Loan Account Category",
    CustomerName: "Customer Name",
    Customer_PhoneNo: "Customer Phone No",
    Address: "Address",
    LatLong: "Lat/Long",
    Co: "Co",
    Co_name: "Co Name",
    LoanAmount: "Loan Amount",
    Application_InterestAmt: "Interest Amount",
    Application_AgreementValue: "Agreement Value",
    Application_LoanEMIAmount: "Loan EMI Amount",
    No_of_EMI: "No. of EMIs",
    Application_LoanTenure: "Loan Tenure",
    LTV: "Loan-to-Value (LTV)",
    ROI: "Rate of Interest (ROI)",
    Application_Case_IRR: "Case IRR",
    Application_Disbursement_IRR: "Disbursement IRR",
    Due_Date: "Due Date",
    Application_ExpiryDate: "Expiry Date",
    Application_AdvInstl: "Advance Installment",
    EMI_Frexvency: "EMI Frequency",
    No_of_Ref: "No. of References",
    Primary_Assets_Type: "Primary Asset Type",
    Additional_Assets_Type: "Additional Asset Type",
    SourceType: "Source Type",
    Product_Name: "Product Name",
    Branch_Name: "Branch Name",
    SourceArea: "Source Area",
    SalesExecutive: "Sales Executive",
    CollectionExecutive: "Collection Executive",
    CollectionArea: "Collection Area",
    CollectionSubarea: "Collection Subarea",
    Disbursment_Bank: "Disbursement Bank",
    Disbursment_Branch: "Disbursement Branch",
    Disbursment_Amount: "Disbursement Amount",
    SPDC_Bank: "SPDC Bank",
    SPDC_Cheque: "SPDC Cheque",
    RPDC_Bank: "RPDC Bank",
    RPDC_Cheque: "RPDC Cheque",
    Application_LoanPurpose: "Loan Purpose",
    EMI_Structure: "EMI Structure",
};


  selectedId: any;
  public Math = Math;
  private _MasterService;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  parentSummary: any;
  FyearId: any;
  maxDate: any;
  minDate: any;
  Types: any;
  ArrTypes: Array<{ id: number; value: string }> = [
    { id: 1, value: "Branch Wise Business" },
    { id: 2, value: "Product Wise Business" },
    { id: 3, value: "Amount Wise Business" },
    { id: 4, value: "Tenure Wise Business" },
    { id: 5, value: "IRR Wise Business" },
    { id: 6, value: "LTV Wise Business" },
    { id: 7, value: "Sales Executive Wise Business" },
    { id: 8, value: "Loan A/c Category Wise Business" },
    { id: 9, value: "Gender Wise Business" },
    { id: 10, value: "Religion Wise Business" },
    { id: 11, value: "Caste Wise Business" },
    { id: 12, value: "Marital Status Wise Business" },
    { id: 13, value: "Profile Wise Business" },
    { id: 14, value: "Nature of Work Wise Business" },
  ];

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private lmsService: LmsService
  ) {
    this._MasterService = MasterService;
  }
  hasChild = (_: number, node: ReportFlatNode) => node.expandable;
  treeControl = new FlatTreeControl<ReportFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );
  private transformer = (node: Report, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      Branch_Name: node.Branch_Name,
      Product_Name: node.Product_Name,
      LoanIds: node.LoanIds,
      NoOfLoans: node.NoOfLoans,
      POS_OS: node.POS_OS,
      IN_Percentage: node.IN_Percentage,
      TotalBusiness: node.TotalBusiness,
      Avg_LTV: node.Avg_LTV,
      Avg_Tenure: node.Avg_Tenure,
      level: level,
    };
  };
  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSourceTree: any;
  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Business Summary");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.ArrTypes;

    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      //console.log("paran", this.FyearId);
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));
          this.FromDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          if (this.maxDate > new Date() && this.minDate < new Date())
            this.ToDate = new Date();
          else this.ToDate = this.maxDate;
          this.dataSource = null;
        });
    });
  }
  removePrefix(value: string): string {
    // Example: remove unwanted prefix, adjust logic as needed
    if (!value) return "";
    // If you want to remove a specific prefix, e.g., "BR-"
    // return value.replace(/^BR-/, '');
    // Or just trim whitespace:
    return value.trim();
  }

  onChangeReportTypes() {
    this.SlabDropdown = false;
    this.SlabId = "";
    this.Types = this.ArrTypes.find((obj: any) => {
      return obj.id == this.ReportType;
    }).value;
    switch (this.ReportType) {
      case "3":
        this.SlabDropdown = true;
        this.getSlabsList("Amount");
        break;
      case "4":
        this.SlabDropdown = true;
        this.getSlabsList("Tenure");
        break;
      case "5":
        this.SlabDropdown = true;
        this.getSlabsList("IRR");
        break;
      case "6":
        this.SlabDropdown = true;
        this.getSlabsList("LTV");
        break;
    }
  }

  onSearchBusinessData() {
    this.chartdata = null;
    this.dataSourceTree = null;
    this.DataDiv = false;
    this.branchItem = [];
    this.productItem = [];
    this.genderItem = [];
    this.maritalStatusItem = [];
    this.salesExecItem = [];
    switch (this.ReportType) {
      case "1":
        this.getReportBranchWiseBusiness();
        break;
      case "2":
        this.getReportProductWiseBusiness();
        break;
      case "3":
        this.getReportAmountWiseBusiness();
        break;
      case "4":
        this.getReportTenureWiseBusiness();
        break;
      case "5":
        this.getReportIRRWiseBusiness();
        break;
      case "6":
        this.getReportLTVWiseBusiness();
        break;
      case "7":
        this.getReportSalesExecutiveWiseBusiness();
        break;
      case "8":
        this.getReportLoanAccCategoryWiseBusiness();
        break;
      case "9":
        this.getReportGenderWiseBusiness();
        break;
      case "10":
        this.getReportReligionWiseBusiness();
        break;
      case "11":
        this.getReportCasteWiseBusiness();
        break;
      case "12":
        this.getReportMaritalStatusWiseBusiness();
        break;
      case "13":
        this.getReportProfileWiseBusiness();
        break;
      case "14":
        this.getReportNatureOfWorkWiseBusiness();
        break;
    }
  }

  getSlabsList(Slab_Type) {
    this._MasterService
      .Get__Slab_dropdown({
        Type: Slab_Type,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((result) => {
        this.SlabData = JSON.parse(JSON.stringify(result));
      });
  }
  totaltypewiseBranch1(type: string): number {
    if (this.dataSourceTree && this.dataSourceTree._treeControl) {
      let sum = 0;
      for (let node of this.dataSourceTree._treeControl.dataNodes) {
        if (node.level === 0) {
          sum += Number(node[type]) || 0;
        }
      }
      return sum;
    }
    return 0;
  }

  productItem: any[] = [];
  genderItem: any[] = [];
  maritalStatusItem: any[] = [];
  salesExecItem: any[] = [];
  branchItem: any[] = [];

  branchwiseDashboard(data) {
    console.log(data);
    const branchName = data.Branch_Name ? data.Branch_Name.trim() : "";
    const branchId = this.branchNameToIdMap[branchName];

    if (!branchId) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "BranchId not found for selected branch.",
        ...this.configSuccess,
      });
      return;
    }
    this.reportsService.BranchWise_Business_Report_Dashboard({
      FromDate: this.FromDate,
      To: this.ToDate,
      LoginUserId: this.currentUser.userId,
      BranchId: branchId
    }).subscribe((res: any) => {
      // this.itemData = res.Item1
      this.productItem = res.Item2
      this.genderItem = res.Item3
      this.updateGenderBreakdown(res.Item3);
      this.maritalStatusItem = res.Item4
      this.salesExecItem = res.Item5
      console.log(this.productItem);
    });
  }
  updateGenderBreakdown(item3: any[]) {
    this.femaleLoans = 0;
    this.maleLoans = 0;
    this.femaleBusiness = 0;
    this.maleBusiness = 0;
    this.femalePercentage = 0;
    this.malePercentage = 0;
    item3.forEach((item: any) => {
      if (item.Customer_Gender === 'F') {
        this.femaleLoans += Number(item.Total_Loan);
        this.femaleBusiness += Number(item.Total_Business);
        this.femalePercentage += Number(item.IN_Percentage);
      } else if (item.Customer_Gender === 'M') {
        this.maleLoans += Number(item.Total_Loan);
        this.maleBusiness += Number(item.Total_Business);
        this.malePercentage += Number(item.IN_Percentage);
      }
    });
    this.Total_Loan = this.femaleLoans + this.maleLoans;
    this.Total_Business = this.femaleBusiness + this.maleBusiness;

  }
  getFemaleArc() {
    return this.Total_Loan > 0 ? Math.round((this.femaleLoans / this.Total_Loan) * 377) : 0;
  }
  getMaleArc() {
    return this.Total_Loan > 0 ? Math.round((this.maleLoans / this.Total_Loan) * 377) : 0;
  }

  productwiseDashboard(data) {
    console.log(data);
    const productName = data.Product_Name ? data.Product_Name.trim() : "";
    const productId = this.productNameToIdMap[productName];

    if (!productId) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "ProductId not found for selected Product.",
        ...this.configSuccess,
      });
      return;
    }
    this.reportsService.ProductWise_Business_Report_Dashboard({
      FromDate: this.FromDate,
      To: this.ToDate,
      LoginUserId: this.currentUser.userId,
      ProductId: productId
    }).subscribe((res: any) => {
      // this.itemData = res.Item1
      this.branchItem = res.Item2
      this.genderItem = res.Item3
      this.updateGenderBreakdown(res.Item3);
      this.maritalStatusItem = res.Item4
      this.salesExecItem = res.Item5
      console.log(this.branchItem);
    });
  }



  getReportBranchWiseBusiness() {
    this.showSpinner = true;
    // this.displayedColumns = [
    //   "BranchId",
    //   "Branch_Name",
    //   "Product_Name",
    //   "NoOfLoans",
    //   "TotalBusiness",
    //   "AvgLoanSize",
    //   "IN_Percentage",
    //   "Action",
    // ];
    this.displayedTreeColumns = [
      "Branch_Name",
      "NoOfLoans",
      "Avg_LTV",
      "Avg_Tenure",
      "TotalBusiness",
      "AvgLoanSize",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_BranchWiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        // Build the mapping here
        this.branchNameToIdMap = {};
        res.forEach((item: any) => {
          if (item.Branch_Name && item.BranchId) {
            this.branchNameToIdMap[item.Branch_Name.trim()] = item.BranchId;
          }
        });
        //console.log(res);
        this.chartdata = res.filter((item: any) => item.ParentId === 0);
        if (res.length > 0) {
          this.getDataforTree(res);
          this.DataDiv = true;
          this.parentSummary = this.chartdata.length > 0 ? this.chartdata[0] : null;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          // this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }
  getReportLoanAccCategoryWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Loan_Acc_Category",
      "NoOfLoans",
      "TotalBusiness",
      "AvgLoanSize",
      "IN_Percentage",
      "Action",
    ];

    this.reportsService
      .Report_LoanAccCategoryWiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }


  getReportProductWiseBusiness() {
    this.showSpinner = true;
    // this.displayedColumns = [
    //   "Id",
    //   "Product_Name",
    //   "NoOfLoans",
    //   "TotalBusiness",
    //   "AvgLoanSize",
    //   "IN_Percentage",
    //   "Action",
    // ];
    this.displayedTreeColumns = [
      "Product_Name",
      // "Branch_Name1",
      "NoOfLoans",
      "Avg_LTV",
      "Avg_Tenure",
      "TotalBusiness",
      "AvgLoanSize",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_ProductWiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        // Build the mapping here
        this.productNameToIdMap = {};
        res.forEach((item: any) => {
          if (item.Product_Name && item.ProductId) {
            this.productNameToIdMap[item.Product_Name.trim()] = item.ProductId;
          }
        });
        //console.log(res);
        this.chartdata = res.filter((item: any) => item.ParentId === 0);
        if (res.length > 0) {
          this.getDataforTree(res);
          this.DataDiv = true;
          this.parentSummary = this.chartdata.length > 0 ? this.chartdata[0] : null;

        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          // this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }
  getReportAmountWiseBusiness() {
    this.showSpinner = true;
    //console.log(this.SlabId);
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_Amount_WiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log("Amount",res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }
  getReportTenureWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_Tenure_WiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log("Tenure",res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }
  getReportIRRWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_IRR_WiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log("IRR",res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }
  getReportLTVWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_LTV_WiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log("LTV",res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  getReportGenderWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Gender",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_GenderWiseBusiness({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        // console.log("Gender wise business report", res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  getReportReligionWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Religion",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_ReligionWiseBusiness({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  getReportCasteWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Cast",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_CastWiseBusiness({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  getReportMaritalStatusWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "MaritalStatus",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_MaritalStatusWiseBusiness({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  getReportProfileWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Customer_Profile",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_ProfileWiseBusiness({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  getReportNatureOfWorkWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Natureofwork",
      "NoOfLoans",
      "TotalBusiness",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_NatureofworkWiseBusiness({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log(res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  getDataforTable(res) {
    this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
    this.dataSource.sort = this.sort;
    this.showSpinner = false;
  }
  getDataforTree(res) {
    // this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
    // this.dataSource.sort = this.sort;
    if (res.length > 0) {
      this.dataSourceTree = new MatTreeFlatDataSource(
        this.treeControl,
        this.treeFlattener
      );

      var tree = this.unflatten(res);
      // console.log("tree", tree);
      this.dataSourceTree.data = tree;
      // this.ExpandBtn = true;
      // this.CollaspeBtn = false;
      this.showSpinner = false;
      this.showSpinner = false;
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No data found",
        ...this.configSuccess,
      });
      this.showSpinner = false;
      this.dataSourceTree = null;
    }
  }
  // OnClickExpandAll() {
  //   this.ExpandBtn = false;
  //   this.CollaspeBtn = true;
  //   this.treeControl.expandAll();
  // }
  // OnClickCollaspeAll() {
  //   this.ExpandBtn = true;
  //   this.CollaspeBtn = false;
  //   this.treeControl.collapseAll();
  // }

  //   unflatten(arr) {
  //   var tree = [],
  //     mappedArr = [],
  //     arrElem,
  //     mappedElem;

  //     for (var i = 0, len = arr.length; i < len; i++) {
  //       arrElem = arr[i];
  //       mappedArr[arrElem.branchId] = arrElem;
  //       mappedArr[arrElem.branchId]["children"] = [];
  //     }
  //     for (var branchId in mappedArr) {
  //       tree.push({
  //         branchId:
  //           mappedArr[branchId].branchId,
  //         Name_type: mappedArr[branchId].Branch_Name,
  //         children: [],
  //       });
  //     }

  //     for (var i = 0; i < tree.length; i++) {

  //       tree[i].POS_OS = 0;
  //       tree[i].IN_Percentage = 0;
  //       tree[i].TotalBusiness = 0;

  //       for (var j = 0; j < arr.length; j++) {
  //         if (arr[j].ParentId == tree[i].ParentId) {
  //           tree[i].POS_OS = tree[i].POS_OS + arr[j].POS_OS;
  //           tree[i].IN_Percentage = tree[i].IN_Percentage + arr[j].IN_Percentage;
  //           tree[i].TotalBusiness = tree[i].TotalBusiness + arr[j].TotalBusiness;

  //           tree[i]["children"].push({
  //             branchId: arr[j].branchId,
  //             Branch_Name: arr[j].Branch_Name,
  //             Product_Name: arr[j].Product_Name,
  //             LoanIds: arr[j].LoanIds,
  //             POS_OS: arr[j].POS_OS,
  //             IN_Percentage: arr[j].IN_Percentage,
  //             TotalBusiness: arr[j].TotalBusiness
  //           });
  //         }
  //       }
  //     }

  //   this.totaltypewise(tree);
  //   return tree;
  // }
  unflatten(arr) {
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;
    let sh;
    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem.Id] = arrElem;
      mappedArr[arrElem.Id]["children"] = [];
    }

    for (var Id in mappedArr) {
      if (mappedArr.hasOwnProperty(Id)) {
        mappedElem = mappedArr[Id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.ParentId > 0) {
          mappedArr[mappedElem["ParentId"]]["children"].push(mappedElem);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }

    return tree;
  }

  totaltypewise(type) {
    if (
      this.dataSource != null &&
      this.dataSource != undefined &&
      this.dataSource != ""
    ) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i][type]);
      }
      switch (type) {
        case "NoOfLoans":
          return sum.toFixed();
          break;
        case "TotalBusiness":
          return sum.toFixed(2);
          break;
        case "IN_Percentage":
          return sum.toFixed() + "%";
          break;
      }
    }
    return 0;
  }
  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `business-summary`,
      sheet: "business-summary",
    });
  }

  DateChange() {
    if (this.FromDate != "" && this.ToDate != "") {
      if (this.FromDate > this.ToDate) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To Date will be greater than to From Date.",
          ...this.configSuccess,
        });
        this.FromDate = "";
        this.ToDate = "";
      }
    }
  }

  goToBookingListDetails(row) {
    this.showSpinner= true;
    this.displayedColumnsModel = [
      "Id",
      "Application_No",
      "Application_Date",
      "LoanAcNo",
      "Loan_Date",
      "Loan_Acc_Category",
      "CustomerName",
      "Customer_PhoneNo",
      "Address",
      "LatLong",
      "Co",
      "Co_name",
      "LoanAmount",
      "Application_InterestAmt",
      "Application_AgreementValue",
      "Application_LoanEMIAmount",
      "No_of_EMI",
      "Application_LoanTenure",
      "LTV",
      "ROI",
      "Application_Case_IRR",
      "Application_Disbursement_IRR",
      "Due_Date",
      "Application_ExpiryDate",
      "Application_AdvInstl",
      "EMI_Frexvency",
      "No_of_Ref",
      "Primary_Assets_Type",
      "Additional_Assets_Type",
      "SourceType",
      "Product_Name",
      "Branch_Name",
      "SourceArea",
      "SalesExecutive",
      "CollectionExecutive",
      "CollectionArea",
      "CollectionSubarea",
      "Disbursment_Bank",
      "Disbursment_Branch",
      "Disbursment_Amount",
      "SPDC_Bank",
      "SPDC_Cheque",
      "RPDC_Bank",
      "RPDC_Cheque",
      "Application_LoanPurpose",
      "EMI_Structure",
    ];
    
    this.paginator.pageIndex = 0;
    this.reportsService
      .Report_Booking_List({
        From: this.FromDate,
        To: this.ToDate,
        LoanAcId: row.LoanIds,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log(res);
        
        if (res.length > 0) {
          this.FileCheckingList = JSON.parse(JSON.stringify(res));
          this.DataSourceModel = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.DataSourceModel.sort = this.sort;
          this.DataSourceModel.paginator = this.paginator;
          $("#ViewBookingListDetails").modal("show");
          $("#ViewBookingListDetails").css("z-index", "1050");
          this.showSpinner= false;
        }
      });
  }
  onCloseDueListDetails() {
    $("#ViewBookingListDetails").modal("hide");
  }

  public highlightRow(row) {
    this.selectedId = row.Loan_Id;
  }

  getReportSalesExecutiveWiseBusiness() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Employee_Name",
      "NoOfLoans",
      "TotalBusiness",
      "AvgLoanSize",
      "IN_Percentage",
      "Action",
    ];
    this.reportsService
      .Report_SalesExecutiveWiseBusiness({
        From: this.FromDate,
        To: this.ToDate,
        SlabId: this.SlabId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log("LTV",res);
        this.chartdata = res;
        if (res.length > 0) {
          this.getDataforTable(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
          this.showSpinner = false;
        }
      });
  }

  exportTableAsXLSX(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "businesswise_model"
    ) as HTMLTableElement;
    const worksheetName = "BUSINESS WISE DETAILS"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  exportTablebookinglist(exporter: any): void {
  exporter.exportTable('xlsx', {
    fileName: 'BUSINESS WISE DETAILS"',
    sheet: 'BUSINESS WISE DETAILS"',
  });
}

  applyFilter(filterValue: string) {
    this.DataSourceModel.filter = filterValue.trim().toLowerCase();
  }
}
